module.exports = __webpack_public_path__ + "static/media/Dashboard_01-Events.51ee74ae.jpg";